import { useApolloClient } from '@apollo/client'
import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  DocumentsDataCollectionDocument,
  DocumentsDocument,
  EmployeeFoldersDocument,
  FoldersDocument,
  RestoreFromTrashBinDocument,
  RestoreFromTrashBinMutation,
  RestoreFromTrashBinMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useRestoreFromTrashBinDocument = ({ fromDataTable = false }: { fromDataTable?: boolean }) => {
  const client = useApolloClient()
  const [restoreDocumentsFromTrashBin, { loading }] = useMutation(RestoreFromTrashBinDocument, {
    extractorFn: (data: RestoreFromTrashBinMutation) =>
      data.documentsMutations.restoreFromTrashBinDocumentsDocument,
  })

  return {
    loading,
    async restoreDocumentsFromTrashBin(variables: RestoreFromTrashBinMutationVariables) {
      const result = await restoreDocumentsFromTrashBin({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })

      client.refetchQueries({
        include: [DocumentsDataCollectionDocument, FoldersDocument, EmployeeFoldersDocument],
      })

      return result
    },
  }
}

export default useRestoreFromTrashBinDocument
